import serviciosData from '../data/servicios';
import ObtenerServicios from '../functions/ObtenerServicios';
import Servicio from '../types/Servicios';

export const CargarServicios = () => {
  return serviciosData;
};

export const CargarServiciosDB = async (prmFiltro: string = '') => {
  const serviciosData = await ObtenerServicios(prmFiltro);
  return serviciosData;
};
